<!--
 * @Descripttion: 大屏设计器 -- 预览
 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div class="layout" :style="{ 'overflow-x': 'auto', 'background-color': bgColor, }" 
   :class="dashboard.style === 'dark'?'workbench-dark':''">
    <a-spin size="large" :spinning="viewLoading">
      <div class="export-btn">
        <div class="top-left">
          <img :src="dashboard.style === 'dark'?logoDark:logo" width="160" alt @click="turnToHome" style="cursor: pointer"/>
          <span v-if="name" class="model-name">&nbsp;-&nbsp;{{name}}</span>
        </div>
      </div>
      <div :style="bigScreenStyle" style="position: relative;">
        <widget
          v-for="(widget, index) in widgets"
          :key="index"
          :index="index"
          v-model="widget.value"
          :type="widget.type"
          @timeChange="dataChange"
          :dashboard="dashboard"
          :name="name"
          :widget="widget"
          ref="widget"
          :searchCondition="searchCondition"
        />
      </div>
    </a-spin> 
  </div>
</template>

<script>
import widget from "../designer/widget/temp";
import { getAnalysisTemplatesDetails, getWidgetsData, getBaseWidgetsData } from '@/api/template'
import {  previewOuter, getAnalysisTemplatesDetailsOuter } from "@/api/shareModal"
import { mapGetters } from 'vuex';
import moment from "moment"

export default {
  name: "NoPermissionView",
  components: {
    widget
  },
  data() {
    return {
      bigScreenStyle: {},
      widgets: [],
      bgColor: '',
      dashboard: {
        style: 'normal'
      },
      name: '',
      logo: require('@/assets/images/logo.svg'),
      logoDark: require('@/assets/images/logo-dark.svg'),
      filterCondition: [],
      searchCondition: [],
      globalDateRang: {}
    };
  },
  provide() {
    return {
      isbase: () => false,
      getDashboardDynamicData: () => this.dashboard?.dynamicData,
      getIndex: () => 0,
      widgetUpdate: () => {},
      filterSearch: this.filterSearch,
      setFilterCondition: this.setFilterCondition,
      getFilterCondition: () => this.filterCondition,
    };
  },
  async mounted() {
    const reportCode = this.$route.query.reportCode;
    console.log(reportCode)
    let canvas = {}
    let widgets = []
    if(reportCode) {
      const { code, data } = await getAnalysisTemplatesDetailsOuter(reportCode);
      if (code != 200) return;
      canvas = data.canvas
      widgets = data.canvas.widgets;
      this.name = data.name
      canvas.customOptions = data.customOptions || {}
      gtag('event', 'share_model_view_out', {
				modelName: data.name,
			});
    } else {
      canvas = localStorage.getItem('viewCanvas')
      if(canvas) {
        canvas = JSON.parse(canvas)
        widgets = canvas.widgets;
        this.name = canvas.name
      }
    }
    this.dashboard.dynamicData = canvas.dynamicData
    this.dashboard.style = canvas.customOptions?.style || 'normal'
    let obj = widgets.find(v => v.type === 'widget-time')
    console.log(obj, '1111')

    let val,value = undefined
    if(obj&&obj.value.setup.timeSelector) {
      val = obj.value.setup.timeSelector
      value = this.$timeSelectorToDate(val)
      value = value.map(v => v.format?v.format('YYYY-MM-DD'):moment(v).format('YYYY-MM-DD'))
      obj.value.setup.value = value
      this.globalDateRang = {
        from: value[0],
        to: value[1],
        timeSelector: val
      }
    }
    widgets.forEach((v ,i) => {
      v.index = i
      if(v.dynamicDataParam&&v.type !== 'widget-table') {
        v.dynamicDataParam.pageSize = 1000
      }
      if(v.dynamicDataParam&&v.type === 'widget-table') {
        v.dynamicDataParam.pageSize = v.value.setup?.pageSize || 10
      }
      // if(canvas.dynamicData&&canvas.dynamicData.contextData?.datasource) {
      //   let context = canvas.dynamicData.contextData
      //   if(v.dynamicDataParam&&!v.dynamicDataParam.datasource) {
      //     v.dynamicDataParam.datasource = context.datasource
      //     v.dynamicDataParam.accountIds = context.accountIds
      //     v.dynamicDataParam.tableId = context.tableId
      //     v.dynamicDataParam.filterType = context.filterType
      //   }
      // }
      if(val&&v.dynamicDataParam && v.dynamicDataParam.globalDateRang) {
        v.dynamicDataParam.globalDateRang = {
          from: value[0],
          to: value[1],
          timeSelector: val
        }
      }
      // 转独立日期
      let contextData = v.value.data?.dynamicData?.contextData
      if(contextData&&contextData.dateRang&&contextData.dateRang.timeSelector) {
        let val = contextData.dateRang.timeSelector
        let value = this.$timeSelectorToDate(val)
        contextData.dateRang = {
          from: value[0],
          to: value[1],
          timeSelector: val
        }
      }
    })
    this.widgets = widgets
    console.log(widgets)
    // text-filter
    let filters = widgets.filter(v => v.type === 'widget-text-filter')
    let filterCondition = []
    try {
      filters.forEach(v => {
        let list = v.value.data.dynamicData
        list.forEach(val => {
          val.value = v.value.data.text
          val.index = v.index
          val.name = val.dimension
          val.relation = 'AND'
        })
        filterCondition = filterCondition.concat(list)
      })
    } catch (error) {
      console.log(error)      
    }
    this.filterCondition = filterCondition
    this.bgColor =  canvas.backgroundColor;
    this.bigScreenStyle = {
      'height': canvas.height + 'px',
      'width': canvas.width + 'px',
      'background-color': canvas.backgroundColor,
      'background-image': canvas.backgroundImage?'url(' + canvas.backgroundImage + ')':'',
      'background-position': '0% 0%',
      'background-size': '100% 100%',
      'background-repeat': 'initial',
      'background-attachment': 'initial',
      'background-origin': 'initial',
      'background-clip': 'initial',
      'margin-left': 'auto',
      'margin-right': 'auto'
    }
    if(!obj) {
      this.getData()
    }
  },
  computed: {
    ...mapGetters({
        viewLoading: 'viewLoading'
    }),
  },
  methods: {
    setFilterCondition(index, value) {
      this.filterCondition.filter(v => v.index === index).forEach(v => {
        v.value = value
      })
    },
    filterSearch() {
      let widgets = this.$deepclone(this.widgets)
      widgets.forEach((v, i) => {
        if(v.type === 'widget-table'&&v.dynamicDataParam) {
          let wRef = this.$refs.widget[i]?.$refs?.component
          v.dynamicDataParam.orders = wRef?.orders?.length?wRef.orders:v.dynamicDataParam.orders
          v.dynamicDataParam.conditions
 = v.dynamicDataParam?.conditions?.concat(wRef?.filterConditions || [])
        }
      })
      this.getData(widgets)
      try {
        let hasDateRangList = widgets.filter((v, i) => v.dynamicDataParam&&v.dynamicDataParam.dateRang&&v.dynamicDataParam.dateRang.from)
        if(hasDateRangList.length) {
          hasDateRangList.forEach(v => {
            this.$refs.widget[v.index].filterSearch()
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    turnToHome() {
      this.$router.push({
        path: '/'
      })
    },
    dataChange(val) {
      this.widgets.forEach(v => {
        if(v.dynamicDataParam && v.dynamicDataParam.globalDateRang) {
          v.dynamicDataParam.globalDateRang = val
        }
        if(v.value.data?.dynamicData?.contextData) {
          v.value.data.dynamicData.contextData.globalDateRang = val
        }
      })
      this.globalDateRang = val
      this.getData()
    },
    async getData() {
      console.log(this.widgets)
      let params = this.widgets.filter(v => v.dynamicDataParam)
      if(params.length) {
        this.$store.commit("modelDesign/SET_VIEW_LOADING", true);
        // let query = this.$route.query
        const reportCode = this.$route.query.reportCode;
        // let api = query.isbase?getBaseWidgetsData:getWidgetsData
        previewOuter(reportCode, {
          globalDateRang: this.globalDateRang,
          globalConditions: this.filterCondition || []
        }).then((res) => {
          let data = res.data || {}
          Object.keys(data).forEach(key => {
            this.$nextTick(() => {
              this.$refs.widget[key].init(data[key])
            })
          })
        }).finally(() => this.$store.commit("modelDesign/SET_VIEW_LOADING", false))
      }
    }
  }
};
</script>

<style scoped lang="less">
.layout {
  width: 100%;
  height: 100%;
  text-align: center;
}
.bottom-text {
  width: 100%;
  color: #a0a0a0;
  position: fixed;
  bottom: 16px;
  z-index: 9999;
}
/deep/ .ant-spin-nested-loading > div > .ant-spin{
  max-height: none;
}

.top-left {
  float: left;
  line-height: 32px;
  margin-left: 24px;
  font-size: 16px;
  overflow: hidden;
  .anticon {
    color: #677392;
    cursor: pointer;
  }
  .model-name {
    font-size: 20px;
    color: #22AC35;
  }
}
.export-btn {
  text-align: right;
  margin-right: 24px;
  margin-top: 12px;
  margin-bottom: 12px;
  overflow: hidden;
}
</style>
